module.exports = __webpack_public_path__ + "assets/SquareBy4PtDetailed.0454fa55c98259c2c764a4576c413929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareBy4PtDetailed.png
// module id = 564
// module chunks = 0